import { NIGHTLIFE_EVENTBRITE_CATEGORY } from '@eventbrite/categories';
import {
    CategoryBrowseNightlifeExperiment,
    TrendingSearchValues,
    useGetStatsigEnrollment,
} from '@eventbrite/discover-utils';
import { gettext } from '@eventbrite/i18n';
import { LoadingSkeleton } from '@eventbrite/loading-skeleton';
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { TrackableComponent } from '../../../../utils/TrackableComponent';
import { CategoryBrowseEvents } from '../../containers/CategoryBrowseEvents';
import { CATEGORY_BROWSE_PLACEMENT } from '../../utils/analytics';

const ELIGIBLE_CATEGORIES = [
    'music',
    'holiday',
    'film-and-media',
    'food-and-drink',
    'comedy',
];

export const NightlifeEvents = withRouter((props: any) => {
    const { category, subcategory } = props.match.params;
    const [enableStatsig, setEnableStatsig] = useState(false);

    const CategoryBrowseNightlifeExperimentVariant = useGetStatsigEnrollment({
        name: CategoryBrowseNightlifeExperiment.name,
        paramName: CategoryBrowseNightlifeExperiment.paramName,
        defaultValue: CategoryBrowseNightlifeExperiment.values.control,
        enabled: enableStatsig,
    });

    const HandleIntersect = () => {
        setEnableStatsig(true);
    };

    if (!ELIGIBLE_CATEGORIES.includes(subcategory || category)) return null;
    return (
        <TrackableComponent onIntersect={HandleIntersect} threshold={0.1}>
            {CategoryBrowseNightlifeExperimentVariant.status == 'loading' ? (
                <LoadingSkeleton height={'250px'} />
            ) : (
                CategoryBrowseNightlifeExperimentVariant.variant ==
                    TrendingSearchValues.test && (
                    <CategoryBrowseEvents
                        queryOverload={{
                            page_size: 25,
                            start_hour_range: {
                                end_hour: 24,
                                start_hour: 20,
                            },
                        }}
                        title={gettext('After 8pm')}
                        bucketName={CATEGORY_BROWSE_PLACEMENT}
                        bucketKey={NIGHTLIFE_EVENTBRITE_CATEGORY}
                        bucketPosition="2"
                        lazyLoadCarouselElements
                        adSlots={[1, 4]}
                    />
                )
            )}
        </TrackableComponent>
    );
});
